export default __webpack_public_path__ + "static/media/ls2_g06.e714264c.png";